import styled from 'styled-components';
import { colorPalette, fontFamily, fontSize, getSpacing } from 'stylesheet';

export const FormRowContainer = styled.div`
  display: flex;
  > * {
    flex: 0.5;
    &:first-child {
      margin-right: ${getSpacing(3)};
    }
  }
  margin-bottom: ${getSpacing(1)};
`;

export const ButtonsContainer = styled.div`
  margin-top: ${getSpacing(5)};
  display: flex;
  justify-content: flex-end;
`;
export const MyProfileFormContainer = styled.div`
  margin-top: ${getSpacing(5)};
`;

export const PasswordSection = styled.div`
  margin-top: ${getSpacing(4)};
  padding-top: ${getSpacing(4)};
  border-top: 1px solid ${colorPalette.grey_100};
`;

export const PasswordInfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: ${getSpacing(2)};
  font-family: ${fontFamily.main};
  font-size: ${fontSize.p1};
`;

export const PasswordInfoLabel = styled.span`
  color: ${colorPalette.grey_600};
`;

export const PasswordInfoValue = styled.span`
  color: ${colorPalette.greyMain};
  font-weight: 600;
  text-align: right;
`;

export const PasswordExpiredValue = styled(PasswordInfoValue)`
  color: ${colorPalette.status_error};
`;

export const ChangePasswordLink = styled.button`
  margin-top: ${getSpacing(1)};
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  color: ${colorPalette.primary};
  font-family: ${fontFamily.main};
  font-size: ${fontSize.p1};
  text-decoration: underline;
`;
